module.exports = __webpack_public_path__ + "f575147e0c42bf41bc50d86fb542269a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SE-VAS.svg
// module id = /0WK
// module chunks = 0